/**
* @params {object} company
* @params {object} [company.channelsConfiguration]
* @params {[string]} [company.channelsConfiguration.oneToMany]
* @params {[string]} [company.channelsConfiguration.manyToMany]
* @params {string} channelToken
**/
export function isToMany(company, channelToken) {
  const { channelsConfiguration } = company || {}
  if (!channelsConfiguration) return false

  const { oneToMany, manyToMany } = channelsConfiguration
  const tokens = (oneToMany || []).concat(manyToMany || [])

  return tokens.includes(channelToken)
}

/**
 * Check is checkedToMany active
 * @param {object} company
 *
 * @returns {boolean}
 */
export function isActiveCheckedToMany(company) {
  const { channelsConfiguration } = company || {}
  if (!channelsConfiguration) return false

  return channelsConfiguration.checkedToMany === true
}

/**
 * Check if is assigned to others operators
 * @param {object} user
 * @param {object} currentUser
 *
 * @returns {string}
 */
export function getAssignToOthers(user, currentUser) {
  const { assignedTo = [] } = user

  //assignedTo === 0 -> morado
  if (assignedTo.length === 0)
    return '-primary'
  //assignedTo === 1 && assignedTo in currentUser -> morado
  if (assignedTo.length === 1 && assignedTo[0] === currentUser._id)
    return '-primary'
  //assignedTo > 1 && assignedTo not in currentUser
  return '-secondary'//'assign-to-others'
}

/**
 * Get right channel name
 * @param {[{channel: string, token: string, origin: string, connectionType: string}]} channels
 *
 * @returns {string}
 */
export function getChannelName(channels) {
  const channelInfo = (channels || [])[0] || {}

  return channelInfo.channel === 'wall'
    ? channelInfo.connectionType || ''
    : channelInfo.provider === 'chatmail' ? channelInfo.provider
      : channelInfo.channel || ''
}

/**
 * Get channel provider
 * @param {[{provider: string}]} channels
 *
 * @returns {string}
 */
export function getChannelProvider(channels) {
  const channelInfo = (channels || [])[0] || {}

  return channelInfo.provider || ''
}

export function getChannelTitle({ name, botName, value, botNameIG }) {
  let title = name || botNameIG || botName || value

  return title
}